import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface StoreProjectAssigneesDeleteDialogIdleProps {
  selectedIdsCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  isPending: boolean;
}

export const StoreProjectAssigneesDeleteDialogIdle = ({
  selectedIdsCount,
  onCancel,
  onConfirm,
  isPending,
}: StoreProjectAssigneesDeleteDialogIdleProps) => {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader>
        <DialogTitle>
          {t("storeProjectAssignees.deleteDialog.title")}
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          {t("storeProjectAssignees.deleteDialog.description", {
            count: selectedIdsCount,
          })}
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onCancel} disabled={isPending}>
            {t("storeProjectAssignees.deleteDialog.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {t("storeProjectAssignees.deleteDialog.confirm")}
          </Button>
        </div>
      </div>
    </>
  );
};
